<template>
  <v-container fluid fill-height align-start ma-0 pa-0>
    <v-card width="100%">
      <v-row no-gutters class="mt-5">
        <v-col cols="12" class="d-flex">
          <span>작성일자 : {{ createDt ? createDt : '-' }}</span>
          <span style="margin-left: 100px;">수정일자 : {{ updateDt ? updateDt : '-' }}</span>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-form class="pt-3" style="width:100%; height:100%;" ref="form">
          <v-sheet
            width="100%"
            height="100%"
            class="overflow-hidden overflow-y-auto"
            :key="componentKey"
          >
            <v-row no-gutters>
              <v-col cols="12" md="12" lg="10" class="pt-0">
                <v-tooltip right color="primary" max-width="240px">
                  <template v-slot:activator="{ on }">
                    <span class="editor-label">
                      <span>{{ '1. 제목' }}</span>
                      <svg-icon icon-class="info" class="ml-1" style="height: 1rem" v-on="on" />
                    </span>
                  </template>
                  <div class="tooltip-text">{{ '안전보건경영 관리 문서의 제목, 출력 시 문서 최상단에 표시됩니다.' }}</div>
                </v-tooltip>
                <v-text-field
                  style="width: 100%;"
                  v-model="params.contentHeader"
                  solo
                  class="editor_bg"
                  placeholder="안전보건경영 방침의 제목을 입력하세요."
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="12" lg="10" class="pt-5">
                <span class="editor-label">{{ '2. 내용' }}</span>
                <v-textarea
                  style="width: 100%;"
                  v-model="params.contentBody"
                  spellcheck="false"
                  no-resize
                  rows="5"
                  row-height="40"
                  solo
                  class="editor_bg"
                  auto-grow
                  placeholder="안전보건경영 방침의 내용을 입력하세요."
                ></v-textarea>
              </v-col>
              <v-col cols="12" md="12" lg="10" class="pt-5">
                <v-tooltip right color="primary" max-width="240px">
                  <template v-slot:activator="{ on }">
                    <span class="editor-label">
                      <span>{{ '3. 하단' }}</span>
                      <svg-icon icon-class="info" class="ml-1" style="height: 1rem" v-on="on" />
                    </span>
                  </template>
                  <div class="tooltip-text">{{ '효력발생일자 등, 출력 시 문서 최하단에 표시됩니다.' }}</div>
                </v-tooltip>
                <v-textarea
                  class="editor_bg"
                  style="width: 100%;"
                  v-model="params.contentFooter"
                  spellcheck="false"
                  rows="5"
                  row-height="20"
                  no-resize
                  solo
                  auto-grow
                  placeholder="효력발생일자 등 문서 최하단에 표시할 내용을 입력하세요."
                ></v-textarea>
              </v-col>
            </v-row>
          </v-sheet>
        </v-form>
      </v-row>
      <i-dxpopup
        v-if="signPopupVisible"
        :popupVisible="signPopupVisible"
        @popupCloseButtonClick="popupCloseButtonClick"
        title="서명 등록"
        :vHtmlContent="'test'"
        height="400"
        width="500"
      >
        <template v-slot:grid>
          <editSign @signPopupClosed="signPopupClosed($event)"></editSign>
        </template>
      </i-dxpopup>
    </v-card>
  </v-container>
</template>

<script>
// 공통 컴포넌트
import baseview from '@/views/base/baseview.vue' //20220414 LYJ base page 추가
import _ from 'lodash'
import { getCurrentDate } from '@/utils/common.js'
import iDxPopup from '@/components/common/iDxPopup.vue'
import editSign from '@/components/sign/editSign.vue'
// API
import { getSHSampleData, saveSHManageData } from '@/api/leaderShip/shManagePolicy'
import { getUserListInfo } from '@/api/system/userManage'
import { getUserCd } from '@/utils/token'
import { getSHManageData } from '@/api/leaderShip/shManagePolicy'

export default {
  mixins: [baseview],
  components: {
    editSign,
    'i-dxpopup': iDxPopup
  },
  props: {
    datasource: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      buttonUseList: [
        'btnSave' // 저장
      ],
      componentKey: 0,
      params: {
        // clntId: this.getClntId(),
        // compId: this.getCompId(),
        // dataType: '00002',
        // contentHeader: '',
        // contentBody: '',
        // contentFooter: ''
      },
      createDt: '',
      updateDt: '',
      signPopupVisible: false
    }
  },
  watch: {
    datasource: {
      deep: true,
      handler() {
        // 데이터 바인딩
        this.dataInit()
      }
    }
  },
  computed: {},
  created() {},
  beforeMount() {},
  mounted() {
    this.dataInit()
  },
  activated() {},
  methods: {
    dataInit() {
      // 테이터 초기 세팅
      this.params = _.cloneDeep(this.datasource)
      if (Object.keys(this.params).length == 0) {
        ;(this.params.clntId = this.getClntId()),
          (this.params.compId = this.getCompId()),
          (this.params.dataType = '00002'),
          (this.params.__created__ = true)
      }
      this.createDt = this.params.createdAt ? this.params.createdAt.substr(0, 19).replaceAll('-', '.') : ''
      this.updateDt = this.params.updatedAt ? this.params.updatedAt.substr(0, 19).replaceAll('-', '.') : ''
    },
    btnSampleLoad() {
      // 예시 보기
      console.log('## 예시보기 클릭')
      this.vToastifyPrompt(this.$t('작성중인 내용이 덮어집니다. 예시를 불러오시겠습니까?'), 'info', async current => {
        this.openLoading()
        // API
        getSHSampleData({ clntId: this.getClntId() }, true)
          .then(res => {
            console.log('#Res', res)
            if (res.success) {
              this.params.contentHeader = res.map.contentHeader
              this.params.contentBody = res.map.contentBody
              this.params.contentFooter = res.map.contentFooter
              this.componentKey++
              this.endloading()
            }
          })
          .catch(e => {
            this.endLoading()
          })
          .finally(() => {
            this.endLoading()
          })
        return
      })
    },
    async btnSave() {
      await getUserListInfo({ clntId: this.getClntId(), userCd: getUserCd() })
        .then(res => {
          if (res.success) {
            console.log('##res', res)
            if (!res.list[0].signature) {
              this.vSnackbar(this.$t('서명 등록이 필요합니다.'), 'warn', 1000)
              this.signPopupVisible = true
            } else {
              // 저장
              this.vToastifyPrompt(
                this.$t('저장하시겠습니까?'),
                'info',
                async current => {
                  const lastTenCharsBody = this.params.contentBody.slice(-10)
                  // 줄바꿈 문자가 있는지 확인
                  if (lastTenCharsBody.includes('\n')) {
                    // 마지막 10번째까지의 문자열에서 공백 문자 제거
                    this.params.contentBody = this.params.contentBody.slice(0, -10) + lastTenCharsBody.trim()
                  }
                  // const lastTenCharsFooter = this.params.contentFooter.slice(-10)
                  // if (lastTenCharsFooter.includes('\n')) {
                  //   // 마지막 10번째까지의 문자열에서 공백 문자 제거
                  //   this.params.contentFooter = this.params.contentFooter.slice(0, -10) + lastTenCharsFooter.trim()
                  // }
                  this.openLoading()
                  saveSHManageData(this.params, true)
                    .then(res => {
                      // this.updateDt = getCurrentDate().replaceAll('-', '.')
                      this.params.__created__ = false
                    })
                    .catch(e => {
                      this.endLoading()
                    })
                    .finally(() => {
                      this.endLoading()
                      console.log('## #new==> ')
                      getSHManageData({ clntId: this.getClntId(), dataType: '00002' }, false).then(res => {
                        this.params = res.clntId ? res : {}
                        this.updateDt = this.params.updatedAt ? this.params.updatedAt.substr(0, 19).replaceAll('-', '.') : ''
                      })
                    })
                },
                null,
                true
              )
            }
          }
        })
        .catch(error => {
          //////console.log(error)
        })
    },
    popupCloseButtonClick() {
      this.signPopupVisible = false
    },
    signPopupClosed(savedData) {
      if (savedData.updateSign) {
        this.btnSave()
      }
      this.signPopupVisible = false
    }
  }
}
</script>

<style lang="scss"></style>
